import React from 'react';
import { connect } from 'react-redux';

// css
//import 'bootstrap/dist/css/bootstrap.css';
//import '@fortawesome/fontawesome-free/css/all.min.css';
//import 'bootstrap-social/bootstrap-social.css';
//import 'react-quill/dist/quill.snow.css';
//import 'codemirror/lib/codemirror.css';
//import 'codemirror/theme/material.css';
//import 'simple-line-icons/css/simple-line-icons.css';
//import 'flag-icon-css/css/flag-icon.min.css';
//import '../../assets/admin/css/index.css';

const PrivateLayout = props => {
    return (
        <div className={'fade show page-container '}>
            <div className={'content '} >
                {props.children}
            </div>
        </div>
    )
}

export default connect(null, null)(PrivateLayout);




// WEBPACK FOOTER //
// ./src/components/private/privateLayout.js